import { render, staticRenderFns } from "./OrderTimeline.vue?vue&type=template&id=144b54e4&scoped=true"
import script from "./OrderTimeline.vue?vue&type=script&lang=js"
export * from "./OrderTimeline.vue?vue&type=script&lang=js"
import style0 from "./OrderTimeline.vue?vue&type=style&index=0&id=144b54e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144b54e4",
  null
  
)

export default component.exports